export const FIND_CARE_PROVIDERS_REQUEST = 'FIND_CARE_PROVIDERS_REQUEST';

export const findCareProvidersRequest = ({
     filter = [],
     sorting = { field: 'id', order: 'ASC' },
     pagination = { page: 1, take: 50 },
 }) => ({
    type: FIND_CARE_PROVIDERS_REQUEST,
    payload: { filter, sorting, pagination },
    meta: {
        sorting,
    }
});
